import { useEffect } from 'react';
import { ClinicalCaseProvider } from '@features/contexts/ClinicalCaseContext';
import { OrganType } from '@/api/apis/case';
import { HeartClinicalData } from './HeartClinicalData';
import { LiverClinicalData } from './LiverClinicalData';
import { LungsClinicalData } from './LungsClinicalData';
import { ClinicalDataType } from '../../types';
import { useRowScroll } from '@/hooks/useRowScroll';

type ClinicalDataProps = {
  data: ClinicalDataType;
  organType?: OrganType;
  ocsPt: string;
  isScs?: boolean;
};

export const ClinicalData = ({ data, organType, ocsPt, isScs = false }: ClinicalDataProps) => {
  const { listContainerRef, listItemRefs } = useRowScroll();

  useEffect(() => {
    if (listContainerRef?.current) {
      listContainerRef.current.scrollBy({ left: listContainerRef.current.scrollWidth });
    }
  }, [data, listContainerRef]);

  const { lactate = [], bile, pfRatio = [] } = data;
  const getData = () => {
    switch (organType) {
      case OrganType.Heart:
        return (
          <HeartClinicalData
            lactate={lactate}
            ocsPt={ocsPt}
            listContainerRef={listContainerRef}
            listItemRefs={listItemRefs}
          />
        );
      case OrganType.Liver:
        return (
          <LiverClinicalData
            lactate={lactate}
            bile={bile}
            ocsPt={ocsPt}
            listContainerRef={listContainerRef}
            listItemRefs={listItemRefs}
          />
        );
      case OrganType.Lungs:
        return (
          <LungsClinicalData
            pfRatio={pfRatio}
            ocsPt={ocsPt}
            listContainerRef={listContainerRef}
            listItemRefs={listItemRefs}
          />
        );
      default:
        return null;
    }
  };

  return (
    <ClinicalCaseProvider isScs={isScs}>
      <div className={`w-full scroll ${organType}`}>{getData()}</div>
    </ClinicalCaseProvider>
  );
};
